import type { IFieldOptions } from '@axo/form/feature/form-input/types';
import { registrationsNumber } from './regsNo';

export const registrationNumberFieldOptions = {
  maxLength: 4,
  registerOptions: {
    required: 'error.required',
    minLength: {
      value: 4,
      message: 'RegistrationNumber.error.length',
    },
    validate: (value) => {
      if (!registrationsNumber.includes(value))
        return 'RegistrationNumber.error.404';
    },
  },
  tooltipValidation: {
    message: 'RegistrationNumber.tooltip',
  },
} satisfies IFieldOptions;
